import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { showAndCloseSidebar } from "../../components/Sidebar/module/actions";
import { selectShowSidebar } from "../../components/Sidebar/module/selector";
import classes from "./SidebarBackdrop.module.scss";
import { IBackdropProps } from "./module/constants";

const mapStateToProps: any  = () =>
  createStructuredSelector({
    show: selectShowSidebar,
  });

const mapDispatchToProps: any  = {
  showSidebar: (show: boolean) => showAndCloseSidebar(show),
};

const Backdrop = (props: IBackdropProps) => {
  const { show, showSidebar } = props;

  if (show) {
    return (
      <div
        className={classes.backdrop}
        onClick={() => showSidebar(false)}
      ></div>
    );
  } else {
    return null;
  }
};

const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(Backdrop);
